import React from 'react';
import { FileText } from 'lucide-react';

const FormsTab = ({
    formsCatalog = [],
    existingFormNames = new Set(),
    isAddingFormId,
    onPreview,
    onAddForm
}) => {
    return (
        <div className="space-y-4">
            <div className="border border-slate-800 rounded-xl p-5 bg-slate-900/70">
                <div className="flex items-center justify-between mb-3">
                    <div>
                        <p className="text-sm font-semibold text-white">Form Templates</p>
                        <p className="text-xs text-slate-500">Preview and add standard forms to this case.</p>
                    </div>
                    <span className="text-xs text-slate-500">{formsCatalog.length} templates</span>
                </div>
                <div className="space-y-2">
                    {formsCatalog.map((form) => {
                        const fileName = (form.fileName || form.name || "").toLowerCase();
                        const isAdded =
                            existingFormNames.has(fileName) || existingFormNames.has((form.name || "").toLowerCase());
                        return (
                            <div
                                key={form.id}
                                className="flex items-center justify-between gap-3 rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2"
                            >
                                <div className="flex items-center gap-3 min-w-0">
                                    <div className="w-9 h-9 rounded-lg bg-slate-800 text-red-300 flex items-center justify-center">
                                        <FileText className="w-4 h-4" />
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm text-slate-200 font-semibold truncate">{form.name}</p>
                                        <p className="text-xs text-slate-500">PDF Template</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        type="button"
                                        onClick={() =>
                                            onPreview({
                                                name: form.name,
                                                url: form.file,
                                                type: form.type || "application/pdf",
                                                canSave: true,
                                                saveName: form.fileName || form.name
                                            })
                                        }
                                        className="px-3 py-1.5 rounded-lg border border-yellow-500/40 text-yellow-300 hover:text-yellow-200 hover:border-yellow-400 transition-colors text-xs font-semibold"
                                    >
                                        Preview
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => onAddForm(form)}
                                        disabled={isAdded || isAddingFormId === form.id}
                                        className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors ${isAdded
                                            ? "bg-emerald-500/10 text-emerald-300 border border-emerald-500/40"
                                            : "bg-slate-800 text-slate-200 border border-slate-700 hover:bg-slate-700"
                                            }`}
                                    >
                                        {isAddingFormId === form.id ? "Adding..." : isAdded ? "Added" : "Add to case"}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default FormsTab;
